import React from "react";
import { Link, Navigate } from "react-router-dom";
import { NEMONTO_TEMPLATE_MAP } from "./templates";

const containerStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "24px 16px 40px",
  fontFamily: "system-ui, sans-serif",
};

const listStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
  gap: "12px",
  listStyle: "none",
  padding: 0,
};

const cardStyle = {
  border: "1px solid #e9ecef",
  borderRadius: "8px",
  padding: "12px",
  background: "#fff",
};

const NemontoPagesIndex = () => {
  const authToken = localStorage.getItem("nemontoAuthToken");
  const pages = Object.entries(NEMONTO_TEMPLATE_MAP);

  if (!authToken) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return (
    <main style={containerStyle}>
      <h1>Nemonto Templates</h1>
      <p>Open any imported template page below.</p>
      <ul style={listStyle}>
        {pages.map(([pageKey, pageEntry]) => (
          <li key={pageKey} style={cardStyle}>
            <Link to={`/pages/${pageKey}`}>{pageEntry.label}</Link>
          </li>
        ))}
      </ul>
    </main>
  );
};

export default NemontoPagesIndex;